// Edit/add forms receive the building as a non-path route param, which is lost on a page refresh.
// If it is missing, send the user back to the list screen (using the current building from the store when there is one)
// instead of rendering a form that would save an orphan record. Returns true when it redirected.
export function redirectToBuildingList (vm, listRouteName) {
  if (vm.$route.params.id || vm.$route.params.buildingId) return false
  const building = vm.$store.state.building.currentBuilding
  if (building && building.id) vm.$router.replace({ name: listRouteName, params: { buildingId: building.id } })
  else vm.$router.replace({ name: 'buildings' })
  return true
}
